import React, { Component } from 'react';
import './Navcharts.css';
import {
    Route,
    NavLink,
    HashRouter
} from "react-router-dom";

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import Contactus from './Contactus';

class Navcharts extends Component {
    constructor() {
        super();
        this.state = { tabIndex: 0 };
      }
    
      onSelect(tabIndex) {
          const { shouldShowHelpTab, showHelpTab } = this.props;
        this.setState({
            tabIndex: tabIndex
        });

        if (shouldShowHelpTab) {
            showHelpTab(false);
        }
      }
    render() {
        const { client = {}, building ={}, noSegmentsFound, shouldShowHelpTab } = this.props;
        const selectedIndex = shouldShowHelpTab ? 2: this.state.tabIndex;
        if(!this.props.building) {
            return null;
        }
        return (
            <Tabs selectedIndex={selectedIndex} onSelect={tabIndex => this.onSelect(tabIndex)} >
                <TabList>
                <Tab>Electrical Profile</Tab>
                <Tab>Heat Profile </Tab>
                <Tab>Help</Tab>
                </TabList>

                <TabPanel>
                    {this.props.renderKWHComponent()}
                </TabPanel>
                <TabPanel>
                    {this.props.renderHeatComponent()}
                </TabPanel>
                <TabPanel>
                   <Contactus clientName={ client.clientName } buildingName={ building ? building.siteName : '' } noSegmentsFound={noSegmentsFound} />
                </TabPanel>
            </Tabs>
        );
    }
}

export default Navcharts;




// WEBPACK FOOTER //
// ./src/components/Navcharts.js